import { SibBaseObject } from "../BaseObject/SibBaseObject";
import { UserBO } from '../user/user-bo';
import { Transaction } from './transaction';

export class Passbook extends SibBaseObject {
    user: UserBO = new UserBO();
    availableBalance: number;
    transactions: Transaction[] = [];
}
